/**
 * AUTO-GENERATED from generate-icons script 🤖 - DO NOT EDIT!
 */

import dynamicHydrate from '@bluheadless/ui-logic/src/dynamic-hydration/dynamic-hydrate'
import EmptyIcon from '../../icon/empty'

export * from './project-related-icons'
export const AbwIcon = dynamicHydrate(() => import('./abw-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AbwIconSvg = dynamicHydrate(() => import('./abw-icon').then((mod) => mod.AbwIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AfgIcon = dynamicHydrate(() => import('./afg-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AfgIconSvg = dynamicHydrate(() => import('./afg-icon').then((mod) => mod.AfgIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AgoIcon = dynamicHydrate(() => import('./ago-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AgoIconSvg = dynamicHydrate(() => import('./ago-icon').then((mod) => mod.AgoIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AiaIcon = dynamicHydrate(() => import('./aia-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AiaIconSvg = dynamicHydrate(() => import('./aia-icon').then((mod) => mod.AiaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AlaIcon = dynamicHydrate(() => import('./ala-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AlaIconSvg = dynamicHydrate(() => import('./ala-icon').then((mod) => mod.AlaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AlbIcon = dynamicHydrate(() => import('./alb-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AlbIconSvg = dynamicHydrate(() => import('./alb-icon').then((mod) => mod.AlbIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AndIcon = dynamicHydrate(() => import('./and-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AndIconSvg = dynamicHydrate(() => import('./and-icon').then((mod) => mod.AndIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AntIcon = dynamicHydrate(() => import('./ant-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AntIconSvg = dynamicHydrate(() => import('./ant-icon').then((mod) => mod.AntIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AreIcon = dynamicHydrate(() => import('./are-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AreIconSvg = dynamicHydrate(() => import('./are-icon').then((mod) => mod.AreIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArgIcon = dynamicHydrate(() => import('./arg-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArgIconSvg = dynamicHydrate(() => import('./arg-icon').then((mod) => mod.ArgIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArmIcon = dynamicHydrate(() => import('./arm-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ArmIconSvg = dynamicHydrate(() => import('./arm-icon').then((mod) => mod.ArmIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AseIcon = dynamicHydrate(() => import('./ase-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AseIconSvg = dynamicHydrate(() => import('./ase-icon').then((mod) => mod.AseIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AsmIcon = dynamicHydrate(() => import('./asm-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AsmIconSvg = dynamicHydrate(() => import('./asm-icon').then((mod) => mod.AsmIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AtaIcon = dynamicHydrate(() => import('./ata-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AtaIconSvg = dynamicHydrate(() => import('./ata-icon').then((mod) => mod.AtaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AtfIcon = dynamicHydrate(() => import('./atf-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AtfIconSvg = dynamicHydrate(() => import('./atf-icon').then((mod) => mod.AtfIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AtgIcon = dynamicHydrate(() => import('./atg-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AtgIconSvg = dynamicHydrate(() => import('./atg-icon').then((mod) => mod.AtgIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AusIcon = dynamicHydrate(() => import('./aus-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AusIconSvg = dynamicHydrate(() => import('./aus-icon').then((mod) => mod.AusIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AutIcon = dynamicHydrate(() => import('./aut-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AutIconSvg = dynamicHydrate(() => import('./aut-icon').then((mod) => mod.AutIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AzeIcon = dynamicHydrate(() => import('./aze-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const AzeIconSvg = dynamicHydrate(() => import('./aze-icon').then((mod) => mod.AzeIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BdiIcon = dynamicHydrate(() => import('./bdi-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BdiIconSvg = dynamicHydrate(() => import('./bdi-icon').then((mod) => mod.BdiIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BelIcon = dynamicHydrate(() => import('./bel-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BelIconSvg = dynamicHydrate(() => import('./bel-icon').then((mod) => mod.BelIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BenIcon = dynamicHydrate(() => import('./ben-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BenIconSvg = dynamicHydrate(() => import('./ben-icon').then((mod) => mod.BenIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BesIcon = dynamicHydrate(() => import('./bes-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BesIconSvg = dynamicHydrate(() => import('./bes-icon').then((mod) => mod.BesIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BfaIcon = dynamicHydrate(() => import('./bfa-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BfaIconSvg = dynamicHydrate(() => import('./bfa-icon').then((mod) => mod.BfaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BgdIcon = dynamicHydrate(() => import('./bgd-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BgdIconSvg = dynamicHydrate(() => import('./bgd-icon').then((mod) => mod.BgdIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BgrIcon = dynamicHydrate(() => import('./bgr-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BgrIconSvg = dynamicHydrate(() => import('./bgr-icon').then((mod) => mod.BgrIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BhrIcon = dynamicHydrate(() => import('./bhr-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BhrIconSvg = dynamicHydrate(() => import('./bhr-icon').then((mod) => mod.BhrIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BhsIcon = dynamicHydrate(() => import('./bhs-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BhsIconSvg = dynamicHydrate(() => import('./bhs-icon').then((mod) => mod.BhsIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BihIcon = dynamicHydrate(() => import('./bih-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BihIconSvg = dynamicHydrate(() => import('./bih-icon').then((mod) => mod.BihIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BlmIcon = dynamicHydrate(() => import('./blm-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BlmIconSvg = dynamicHydrate(() => import('./blm-icon').then((mod) => mod.BlmIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BlrIcon = dynamicHydrate(() => import('./blr-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BlrIconSvg = dynamicHydrate(() => import('./blr-icon').then((mod) => mod.BlrIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BlzIcon = dynamicHydrate(() => import('./blz-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BlzIconSvg = dynamicHydrate(() => import('./blz-icon').then((mod) => mod.BlzIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BmuIcon = dynamicHydrate(() => import('./bmu-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BmuIconSvg = dynamicHydrate(() => import('./bmu-icon').then((mod) => mod.BmuIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BolIcon = dynamicHydrate(() => import('./bol-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BolIconSvg = dynamicHydrate(() => import('./bol-icon').then((mod) => mod.BolIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BraIcon = dynamicHydrate(() => import('./bra-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BraIconSvg = dynamicHydrate(() => import('./bra-icon').then((mod) => mod.BraIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BrbIcon = dynamicHydrate(() => import('./brb-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BrbIconSvg = dynamicHydrate(() => import('./brb-icon').then((mod) => mod.BrbIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BrnIcon = dynamicHydrate(() => import('./brn-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BrnIconSvg = dynamicHydrate(() => import('./brn-icon').then((mod) => mod.BrnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BtnIcon = dynamicHydrate(() => import('./btn-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BtnIconSvg = dynamicHydrate(() => import('./btn-icon').then((mod) => mod.BtnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BvtIcon = dynamicHydrate(() => import('./bvt-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BvtIconSvg = dynamicHydrate(() => import('./bvt-icon').then((mod) => mod.BvtIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BwaIcon = dynamicHydrate(() => import('./bwa-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const BwaIconSvg = dynamicHydrate(() => import('./bwa-icon').then((mod) => mod.BwaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CafIcon = dynamicHydrate(() => import('./caf-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CafIconSvg = dynamicHydrate(() => import('./caf-icon').then((mod) => mod.CafIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CanIcon = dynamicHydrate(() => import('./can-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CanIconSvg = dynamicHydrate(() => import('./can-icon').then((mod) => mod.CanIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CckIcon = dynamicHydrate(() => import('./cck-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CckIconSvg = dynamicHydrate(() => import('./cck-icon').then((mod) => mod.CckIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CheIcon = dynamicHydrate(() => import('./che-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CheIconSvg = dynamicHydrate(() => import('./che-icon').then((mod) => mod.CheIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ChlIcon = dynamicHydrate(() => import('./chl-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ChlIconSvg = dynamicHydrate(() => import('./chl-icon').then((mod) => mod.ChlIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ChnIcon = dynamicHydrate(() => import('./chn-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ChnIconSvg = dynamicHydrate(() => import('./chn-icon').then((mod) => mod.ChnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CivIcon = dynamicHydrate(() => import('./civ-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CivIconSvg = dynamicHydrate(() => import('./civ-icon').then((mod) => mod.CivIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CmrIcon = dynamicHydrate(() => import('./cmr-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CmrIconSvg = dynamicHydrate(() => import('./cmr-icon').then((mod) => mod.CmrIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CodIcon = dynamicHydrate(() => import('./cod-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CodIconSvg = dynamicHydrate(() => import('./cod-icon').then((mod) => mod.CodIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CogIcon = dynamicHydrate(() => import('./cog-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CogIconSvg = dynamicHydrate(() => import('./cog-icon').then((mod) => mod.CogIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CokIcon = dynamicHydrate(() => import('./cok-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CokIconSvg = dynamicHydrate(() => import('./cok-icon').then((mod) => mod.CokIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ColIcon = dynamicHydrate(() => import('./col-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ColIconSvg = dynamicHydrate(() => import('./col-icon').then((mod) => mod.ColIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ComIcon = dynamicHydrate(() => import('./com-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ComIconSvg = dynamicHydrate(() => import('./com-icon').then((mod) => mod.ComIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CpvIcon = dynamicHydrate(() => import('./cpv-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CpvIconSvg = dynamicHydrate(() => import('./cpv-icon').then((mod) => mod.CpvIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CriIcon = dynamicHydrate(() => import('./cri-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CriIconSvg = dynamicHydrate(() => import('./cri-icon').then((mod) => mod.CriIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CubIcon = dynamicHydrate(() => import('./cub-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CubIconSvg = dynamicHydrate(() => import('./cub-icon').then((mod) => mod.CubIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CuwIcon = dynamicHydrate(() => import('./cuw-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CuwIconSvg = dynamicHydrate(() => import('./cuw-icon').then((mod) => mod.CuwIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CxrIcon = dynamicHydrate(() => import('./cxr-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CxrIconSvg = dynamicHydrate(() => import('./cxr-icon').then((mod) => mod.CxrIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CymIcon = dynamicHydrate(() => import('./cym-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CymIconSvg = dynamicHydrate(() => import('./cym-icon').then((mod) => mod.CymIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CypIcon = dynamicHydrate(() => import('./cyp-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CypIconSvg = dynamicHydrate(() => import('./cyp-icon').then((mod) => mod.CypIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CzeIcon = dynamicHydrate(() => import('./cze-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const CzeIconSvg = dynamicHydrate(() => import('./cze-icon').then((mod) => mod.CzeIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DeuIcon = dynamicHydrate(() => import('./deu-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DeuIconSvg = dynamicHydrate(() => import('./deu-icon').then((mod) => mod.DeuIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DjiIcon = dynamicHydrate(() => import('./dji-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DjiIconSvg = dynamicHydrate(() => import('./dji-icon').then((mod) => mod.DjiIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DmaIcon = dynamicHydrate(() => import('./dma-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DmaIconSvg = dynamicHydrate(() => import('./dma-icon').then((mod) => mod.DmaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DnkIcon = dynamicHydrate(() => import('./dnk-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DnkIconSvg = dynamicHydrate(() => import('./dnk-icon').then((mod) => mod.DnkIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DomIcon = dynamicHydrate(() => import('./dom-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DomIconSvg = dynamicHydrate(() => import('./dom-icon').then((mod) => mod.DomIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DzaIcon = dynamicHydrate(() => import('./dza-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const DzaIconSvg = dynamicHydrate(() => import('./dza-icon').then((mod) => mod.DzaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EcuIcon = dynamicHydrate(() => import('./ecu-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EcuIconSvg = dynamicHydrate(() => import('./ecu-icon').then((mod) => mod.EcuIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EgyIcon = dynamicHydrate(() => import('./egy-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EgyIconSvg = dynamicHydrate(() => import('./egy-icon').then((mod) => mod.EgyIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EriIcon = dynamicHydrate(() => import('./eri-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EriIconSvg = dynamicHydrate(() => import('./eri-icon').then((mod) => mod.EriIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EshIcon = dynamicHydrate(() => import('./esh-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EshIconSvg = dynamicHydrate(() => import('./esh-icon').then((mod) => mod.EshIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EspIcon = dynamicHydrate(() => import('./esp-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EspIconSvg = dynamicHydrate(() => import('./esp-icon').then((mod) => mod.EspIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EstIcon = dynamicHydrate(() => import('./est-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EstIconSvg = dynamicHydrate(() => import('./est-icon').then((mod) => mod.EstIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EthIcon = dynamicHydrate(() => import('./eth-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EthIconSvg = dynamicHydrate(() => import('./eth-icon').then((mod) => mod.EthIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EuIcon = dynamicHydrate(() => import('./eu-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const EuIconSvg = dynamicHydrate(() => import('./eu-icon').then((mod) => mod.EuIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FinIcon = dynamicHydrate(() => import('./fin-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FinIconSvg = dynamicHydrate(() => import('./fin-icon').then((mod) => mod.FinIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FjiIcon = dynamicHydrate(() => import('./fji-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FjiIconSvg = dynamicHydrate(() => import('./fji-icon').then((mod) => mod.FjiIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FlkIcon = dynamicHydrate(() => import('./flk-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FlkIconSvg = dynamicHydrate(() => import('./flk-icon').then((mod) => mod.FlkIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FraIcon = dynamicHydrate(() => import('./fra-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FraIconSvg = dynamicHydrate(() => import('./fra-icon').then((mod) => mod.FraIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FroIcon = dynamicHydrate(() => import('./fro-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FroIconSvg = dynamicHydrate(() => import('./fro-icon').then((mod) => mod.FroIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FsmIcon = dynamicHydrate(() => import('./fsm-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const FsmIconSvg = dynamicHydrate(() => import('./fsm-icon').then((mod) => mod.FsmIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GabIcon = dynamicHydrate(() => import('./gab-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GabIconSvg = dynamicHydrate(() => import('./gab-icon').then((mod) => mod.GabIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbEngIcon = dynamicHydrate(() => import('./gb-eng-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbEngIconSvg = dynamicHydrate(() => import('./gb-eng-icon').then((mod) => mod.GbEngIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbNirIcon = dynamicHydrate(() => import('./gb-nir-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbNirIconSvg = dynamicHydrate(() => import('./gb-nir-icon').then((mod) => mod.GbNirIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbSctIcon = dynamicHydrate(() => import('./gb-sct-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbSctIconSvg = dynamicHydrate(() => import('./gb-sct-icon').then((mod) => mod.GbSctIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbWlsIcon = dynamicHydrate(() => import('./gb-wls-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbWlsIconSvg = dynamicHydrate(() => import('./gb-wls-icon').then((mod) => mod.GbWlsIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbrIcon = dynamicHydrate(() => import('./gbr-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GbrIconSvg = dynamicHydrate(() => import('./gbr-icon').then((mod) => mod.GbrIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GeoIcon = dynamicHydrate(() => import('./geo-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GeoIconSvg = dynamicHydrate(() => import('./geo-icon').then((mod) => mod.GeoIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GgyIcon = dynamicHydrate(() => import('./ggy-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GgyIconSvg = dynamicHydrate(() => import('./ggy-icon').then((mod) => mod.GgyIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GhaIcon = dynamicHydrate(() => import('./gha-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GhaIconSvg = dynamicHydrate(() => import('./gha-icon').then((mod) => mod.GhaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GibIcon = dynamicHydrate(() => import('./gib-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GibIconSvg = dynamicHydrate(() => import('./gib-icon').then((mod) => mod.GibIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GinIcon = dynamicHydrate(() => import('./gin-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GinIconSvg = dynamicHydrate(() => import('./gin-icon').then((mod) => mod.GinIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GmbIcon = dynamicHydrate(() => import('./gmb-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GmbIconSvg = dynamicHydrate(() => import('./gmb-icon').then((mod) => mod.GmbIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GnbIcon = dynamicHydrate(() => import('./gnb-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GnbIconSvg = dynamicHydrate(() => import('./gnb-icon').then((mod) => mod.GnbIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GnqIcon = dynamicHydrate(() => import('./gnq-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GnqIconSvg = dynamicHydrate(() => import('./gnq-icon').then((mod) => mod.GnqIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GrcIcon = dynamicHydrate(() => import('./grc-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GrcIconSvg = dynamicHydrate(() => import('./grc-icon').then((mod) => mod.GrcIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GrdIcon = dynamicHydrate(() => import('./grd-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GrdIconSvg = dynamicHydrate(() => import('./grd-icon').then((mod) => mod.GrdIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GrlIcon = dynamicHydrate(() => import('./grl-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GrlIconSvg = dynamicHydrate(() => import('./grl-icon').then((mod) => mod.GrlIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GtmIcon = dynamicHydrate(() => import('./gtm-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GtmIconSvg = dynamicHydrate(() => import('./gtm-icon').then((mod) => mod.GtmIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GufIcon = dynamicHydrate(() => import('./guf-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GufIconSvg = dynamicHydrate(() => import('./guf-icon').then((mod) => mod.GufIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GumIcon = dynamicHydrate(() => import('./gum-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GumIconSvg = dynamicHydrate(() => import('./gum-icon').then((mod) => mod.GumIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GuyIcon = dynamicHydrate(() => import('./guy-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const GuyIconSvg = dynamicHydrate(() => import('./guy-icon').then((mod) => mod.GuyIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HkgIcon = dynamicHydrate(() => import('./hkg-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HkgIconSvg = dynamicHydrate(() => import('./hkg-icon').then((mod) => mod.HkgIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HmdIcon = dynamicHydrate(() => import('./hmd-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HmdIconSvg = dynamicHydrate(() => import('./hmd-icon').then((mod) => mod.HmdIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HndIcon = dynamicHydrate(() => import('./hnd-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HndIconSvg = dynamicHydrate(() => import('./hnd-icon').then((mod) => mod.HndIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HrvIcon = dynamicHydrate(() => import('./hrv-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HrvIconSvg = dynamicHydrate(() => import('./hrv-icon').then((mod) => mod.HrvIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HtiIcon = dynamicHydrate(() => import('./hti-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HtiIconSvg = dynamicHydrate(() => import('./hti-icon').then((mod) => mod.HtiIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HunIcon = dynamicHydrate(() => import('./hun-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const HunIconSvg = dynamicHydrate(() => import('./hun-icon').then((mod) => mod.HunIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IdnIcon = dynamicHydrate(() => import('./idn-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IdnIconSvg = dynamicHydrate(() => import('./idn-icon').then((mod) => mod.IdnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ImnIcon = dynamicHydrate(() => import('./imn-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ImnIconSvg = dynamicHydrate(() => import('./imn-icon').then((mod) => mod.ImnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IndIcon = dynamicHydrate(() => import('./ind-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IndIconSvg = dynamicHydrate(() => import('./ind-icon').then((mod) => mod.IndIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IotIcon = dynamicHydrate(() => import('./iot-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IotIconSvg = dynamicHydrate(() => import('./iot-icon').then((mod) => mod.IotIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IrlIcon = dynamicHydrate(() => import('./irl-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IrlIconSvg = dynamicHydrate(() => import('./irl-icon').then((mod) => mod.IrlIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IrnIcon = dynamicHydrate(() => import('./irn-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IrnIconSvg = dynamicHydrate(() => import('./irn-icon').then((mod) => mod.IrnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IrqIcon = dynamicHydrate(() => import('./irq-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IrqIconSvg = dynamicHydrate(() => import('./irq-icon').then((mod) => mod.IrqIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IslIcon = dynamicHydrate(() => import('./isl-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IslIconSvg = dynamicHydrate(() => import('./isl-icon').then((mod) => mod.IslIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IsrIcon = dynamicHydrate(() => import('./isr-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const IsrIconSvg = dynamicHydrate(() => import('./isr-icon').then((mod) => mod.IsrIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ItaIcon = dynamicHydrate(() => import('./ita-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ItaIconSvg = dynamicHydrate(() => import('./ita-icon').then((mod) => mod.ItaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JamIcon = dynamicHydrate(() => import('./jam-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JamIconSvg = dynamicHydrate(() => import('./jam-icon').then((mod) => mod.JamIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JeyIcon = dynamicHydrate(() => import('./jey-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JeyIconSvg = dynamicHydrate(() => import('./jey-icon').then((mod) => mod.JeyIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JorIcon = dynamicHydrate(() => import('./jor-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JorIconSvg = dynamicHydrate(() => import('./jor-icon').then((mod) => mod.JorIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JpnIcon = dynamicHydrate(() => import('./jpn-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const JpnIconSvg = dynamicHydrate(() => import('./jpn-icon').then((mod) => mod.JpnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KazIcon = dynamicHydrate(() => import('./kaz-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KazIconSvg = dynamicHydrate(() => import('./kaz-icon').then((mod) => mod.KazIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KenIcon = dynamicHydrate(() => import('./ken-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KenIconSvg = dynamicHydrate(() => import('./ken-icon').then((mod) => mod.KenIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KgzIcon = dynamicHydrate(() => import('./kgz-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KgzIconSvg = dynamicHydrate(() => import('./kgz-icon').then((mod) => mod.KgzIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KhmIcon = dynamicHydrate(() => import('./khm-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KhmIconSvg = dynamicHydrate(() => import('./khm-icon').then((mod) => mod.KhmIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KirIcon = dynamicHydrate(() => import('./kir-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KirIconSvg = dynamicHydrate(() => import('./kir-icon').then((mod) => mod.KirIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KnaIcon = dynamicHydrate(() => import('./kna-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KnaIconSvg = dynamicHydrate(() => import('./kna-icon').then((mod) => mod.KnaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KorIcon = dynamicHydrate(() => import('./kor-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KorIconSvg = dynamicHydrate(() => import('./kor-icon').then((mod) => mod.KorIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KwtIcon = dynamicHydrate(() => import('./kwt-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const KwtIconSvg = dynamicHydrate(() => import('./kwt-icon').then((mod) => mod.KwtIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LaoIcon = dynamicHydrate(() => import('./lao-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LaoIconSvg = dynamicHydrate(() => import('./lao-icon').then((mod) => mod.LaoIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LbnIcon = dynamicHydrate(() => import('./lbn-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LbnIconSvg = dynamicHydrate(() => import('./lbn-icon').then((mod) => mod.LbnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LbrIcon = dynamicHydrate(() => import('./lbr-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LbrIconSvg = dynamicHydrate(() => import('./lbr-icon').then((mod) => mod.LbrIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LbyIcon = dynamicHydrate(() => import('./lby-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LbyIconSvg = dynamicHydrate(() => import('./lby-icon').then((mod) => mod.LbyIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LcaIcon = dynamicHydrate(() => import('./lca-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LcaIconSvg = dynamicHydrate(() => import('./lca-icon').then((mod) => mod.LcaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LieIcon = dynamicHydrate(() => import('./lie-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LieIconSvg = dynamicHydrate(() => import('./lie-icon').then((mod) => mod.LieIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LkaIcon = dynamicHydrate(() => import('./lka-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LkaIconSvg = dynamicHydrate(() => import('./lka-icon').then((mod) => mod.LkaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LsoIcon = dynamicHydrate(() => import('./lso-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LsoIconSvg = dynamicHydrate(() => import('./lso-icon').then((mod) => mod.LsoIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LtuIcon = dynamicHydrate(() => import('./ltu-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LtuIconSvg = dynamicHydrate(() => import('./ltu-icon').then((mod) => mod.LtuIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LuxIcon = dynamicHydrate(() => import('./lux-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LuxIconSvg = dynamicHydrate(() => import('./lux-icon').then((mod) => mod.LuxIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LvaIcon = dynamicHydrate(() => import('./lva-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const LvaIconSvg = dynamicHydrate(() => import('./lva-icon').then((mod) => mod.LvaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MacIcon = dynamicHydrate(() => import('./mac-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MacIconSvg = dynamicHydrate(() => import('./mac-icon').then((mod) => mod.MacIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MafIcon = dynamicHydrate(() => import('./maf-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MafIconSvg = dynamicHydrate(() => import('./maf-icon').then((mod) => mod.MafIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MarIcon = dynamicHydrate(() => import('./mar-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MarIconSvg = dynamicHydrate(() => import('./mar-icon').then((mod) => mod.MarIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const McoIcon = dynamicHydrate(() => import('./mco-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const McoIconSvg = dynamicHydrate(() => import('./mco-icon').then((mod) => mod.McoIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MdaIcon = dynamicHydrate(() => import('./mda-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MdaIconSvg = dynamicHydrate(() => import('./mda-icon').then((mod) => mod.MdaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MdgIcon = dynamicHydrate(() => import('./mdg-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MdgIconSvg = dynamicHydrate(() => import('./mdg-icon').then((mod) => mod.MdgIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MdvIcon = dynamicHydrate(() => import('./mdv-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MdvIconSvg = dynamicHydrate(() => import('./mdv-icon').then((mod) => mod.MdvIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MexIcon = dynamicHydrate(() => import('./mex-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MexIconSvg = dynamicHydrate(() => import('./mex-icon').then((mod) => mod.MexIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MhlIcon = dynamicHydrate(() => import('./mhl-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MhlIconSvg = dynamicHydrate(() => import('./mhl-icon').then((mod) => mod.MhlIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MkdIcon = dynamicHydrate(() => import('./mkd-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MkdIconSvg = dynamicHydrate(() => import('./mkd-icon').then((mod) => mod.MkdIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MliIcon = dynamicHydrate(() => import('./mli-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MliIconSvg = dynamicHydrate(() => import('./mli-icon').then((mod) => mod.MliIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MltIcon = dynamicHydrate(() => import('./mlt-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MltIconSvg = dynamicHydrate(() => import('./mlt-icon').then((mod) => mod.MltIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MmrIcon = dynamicHydrate(() => import('./mmr-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MmrIconSvg = dynamicHydrate(() => import('./mmr-icon').then((mod) => mod.MmrIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MneIcon = dynamicHydrate(() => import('./mne-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MneIconSvg = dynamicHydrate(() => import('./mne-icon').then((mod) => mod.MneIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MngIcon = dynamicHydrate(() => import('./mng-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MngIconSvg = dynamicHydrate(() => import('./mng-icon').then((mod) => mod.MngIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MnpIcon = dynamicHydrate(() => import('./mnp-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MnpIconSvg = dynamicHydrate(() => import('./mnp-icon').then((mod) => mod.MnpIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MozIcon = dynamicHydrate(() => import('./moz-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MozIconSvg = dynamicHydrate(() => import('./moz-icon').then((mod) => mod.MozIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MrtIcon = dynamicHydrate(() => import('./mrt-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MrtIconSvg = dynamicHydrate(() => import('./mrt-icon').then((mod) => mod.MrtIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MsrIcon = dynamicHydrate(() => import('./msr-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MsrIconSvg = dynamicHydrate(() => import('./msr-icon').then((mod) => mod.MsrIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MtqIcon = dynamicHydrate(() => import('./mtq-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MtqIconSvg = dynamicHydrate(() => import('./mtq-icon').then((mod) => mod.MtqIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MusIcon = dynamicHydrate(() => import('./mus-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MusIconSvg = dynamicHydrate(() => import('./mus-icon').then((mod) => mod.MusIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MwiIcon = dynamicHydrate(() => import('./mwi-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MwiIconSvg = dynamicHydrate(() => import('./mwi-icon').then((mod) => mod.MwiIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MysIcon = dynamicHydrate(() => import('./mys-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MysIconSvg = dynamicHydrate(() => import('./mys-icon').then((mod) => mod.MysIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MytIcon = dynamicHydrate(() => import('./myt-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const MytIconSvg = dynamicHydrate(() => import('./myt-icon').then((mod) => mod.MytIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NamIcon = dynamicHydrate(() => import('./nam-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NamIconSvg = dynamicHydrate(() => import('./nam-icon').then((mod) => mod.NamIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NclIcon = dynamicHydrate(() => import('./ncl-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NclIconSvg = dynamicHydrate(() => import('./ncl-icon').then((mod) => mod.NclIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NcyIcon = dynamicHydrate(() => import('./ncy-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NcyIconSvg = dynamicHydrate(() => import('./ncy-icon').then((mod) => mod.NcyIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NerIcon = dynamicHydrate(() => import('./ner-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NerIconSvg = dynamicHydrate(() => import('./ner-icon').then((mod) => mod.NerIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NfkIcon = dynamicHydrate(() => import('./nfk-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NfkIconSvg = dynamicHydrate(() => import('./nfk-icon').then((mod) => mod.NfkIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NgaIcon = dynamicHydrate(() => import('./nga-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NgaIconSvg = dynamicHydrate(() => import('./nga-icon').then((mod) => mod.NgaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NicIcon = dynamicHydrate(() => import('./nic-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NicIconSvg = dynamicHydrate(() => import('./nic-icon').then((mod) => mod.NicIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NiuIcon = dynamicHydrate(() => import('./niu-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NiuIconSvg = dynamicHydrate(() => import('./niu-icon').then((mod) => mod.NiuIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NldIcon = dynamicHydrate(() => import('./nld-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NldIconSvg = dynamicHydrate(() => import('./nld-icon').then((mod) => mod.NldIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NorIcon = dynamicHydrate(() => import('./nor-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NorIconSvg = dynamicHydrate(() => import('./nor-icon').then((mod) => mod.NorIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NplIcon = dynamicHydrate(() => import('./npl-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NplIconSvg = dynamicHydrate(() => import('./npl-icon').then((mod) => mod.NplIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NruIcon = dynamicHydrate(() => import('./nru-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NruIconSvg = dynamicHydrate(() => import('./nru-icon').then((mod) => mod.NruIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NzlIcon = dynamicHydrate(() => import('./nzl-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const NzlIconSvg = dynamicHydrate(() => import('./nzl-icon').then((mod) => mod.NzlIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const OmnIcon = dynamicHydrate(() => import('./omn-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const OmnIconSvg = dynamicHydrate(() => import('./omn-icon').then((mod) => mod.OmnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PakIcon = dynamicHydrate(() => import('./pak-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PakIconSvg = dynamicHydrate(() => import('./pak-icon').then((mod) => mod.PakIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PanIcon = dynamicHydrate(() => import('./pan-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PanIconSvg = dynamicHydrate(() => import('./pan-icon').then((mod) => mod.PanIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PcnIcon = dynamicHydrate(() => import('./pcn-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PcnIconSvg = dynamicHydrate(() => import('./pcn-icon').then((mod) => mod.PcnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PerIcon = dynamicHydrate(() => import('./per-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PerIconSvg = dynamicHydrate(() => import('./per-icon').then((mod) => mod.PerIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PhlIcon = dynamicHydrate(() => import('./phl-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PhlIconSvg = dynamicHydrate(() => import('./phl-icon').then((mod) => mod.PhlIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PlwIcon = dynamicHydrate(() => import('./plw-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PlwIconSvg = dynamicHydrate(() => import('./plw-icon').then((mod) => mod.PlwIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PngIcon = dynamicHydrate(() => import('./png-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PngIconSvg = dynamicHydrate(() => import('./png-icon').then((mod) => mod.PngIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PolIcon = dynamicHydrate(() => import('./pol-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PolIconSvg = dynamicHydrate(() => import('./pol-icon').then((mod) => mod.PolIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PriIcon = dynamicHydrate(() => import('./pri-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PriIconSvg = dynamicHydrate(() => import('./pri-icon').then((mod) => mod.PriIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PrkIcon = dynamicHydrate(() => import('./prk-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PrkIconSvg = dynamicHydrate(() => import('./prk-icon').then((mod) => mod.PrkIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PrtIcon = dynamicHydrate(() => import('./prt-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PrtIconSvg = dynamicHydrate(() => import('./prt-icon').then((mod) => mod.PrtIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PryIcon = dynamicHydrate(() => import('./pry-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PryIconSvg = dynamicHydrate(() => import('./pry-icon').then((mod) => mod.PryIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PseIcon = dynamicHydrate(() => import('./pse-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PseIconSvg = dynamicHydrate(() => import('./pse-icon').then((mod) => mod.PseIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PyfIcon = dynamicHydrate(() => import('./pyf-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const PyfIconSvg = dynamicHydrate(() => import('./pyf-icon').then((mod) => mod.PyfIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const QatIcon = dynamicHydrate(() => import('./qat-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const QatIconSvg = dynamicHydrate(() => import('./qat-icon').then((mod) => mod.QatIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ReuIcon = dynamicHydrate(() => import('./reu-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ReuIconSvg = dynamicHydrate(() => import('./reu-icon').then((mod) => mod.ReuIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RouIcon = dynamicHydrate(() => import('./rou-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RouIconSvg = dynamicHydrate(() => import('./rou-icon').then((mod) => mod.RouIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RusIcon = dynamicHydrate(() => import('./rus-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RusIconSvg = dynamicHydrate(() => import('./rus-icon').then((mod) => mod.RusIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RwaIcon = dynamicHydrate(() => import('./rwa-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const RwaIconSvg = dynamicHydrate(() => import('./rwa-icon').then((mod) => mod.RwaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SauIcon = dynamicHydrate(() => import('./sau-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SauIconSvg = dynamicHydrate(() => import('./sau-icon').then((mod) => mod.SauIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SdnIcon = dynamicHydrate(() => import('./sdn-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SdnIconSvg = dynamicHydrate(() => import('./sdn-icon').then((mod) => mod.SdnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SenIcon = dynamicHydrate(() => import('./sen-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SenIconSvg = dynamicHydrate(() => import('./sen-icon').then((mod) => mod.SenIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SgpIcon = dynamicHydrate(() => import('./sgp-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SgpIconSvg = dynamicHydrate(() => import('./sgp-icon').then((mod) => mod.SgpIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SgsIcon = dynamicHydrate(() => import('./sgs-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SgsIconSvg = dynamicHydrate(() => import('./sgs-icon').then((mod) => mod.SgsIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ShnIcon = dynamicHydrate(() => import('./shn-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ShnIconSvg = dynamicHydrate(() => import('./shn-icon').then((mod) => mod.ShnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SjmIcon = dynamicHydrate(() => import('./sjm-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SjmIconSvg = dynamicHydrate(() => import('./sjm-icon').then((mod) => mod.SjmIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SlbIcon = dynamicHydrate(() => import('./slb-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SlbIconSvg = dynamicHydrate(() => import('./slb-icon').then((mod) => mod.SlbIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SleIcon = dynamicHydrate(() => import('./sle-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SleIconSvg = dynamicHydrate(() => import('./sle-icon').then((mod) => mod.SleIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SlvIcon = dynamicHydrate(() => import('./slv-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SlvIconSvg = dynamicHydrate(() => import('./slv-icon').then((mod) => mod.SlvIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SmrIcon = dynamicHydrate(() => import('./smr-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SmrIconSvg = dynamicHydrate(() => import('./smr-icon').then((mod) => mod.SmrIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SomIcon = dynamicHydrate(() => import('./som-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SomIconSvg = dynamicHydrate(() => import('./som-icon').then((mod) => mod.SomIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SpmIcon = dynamicHydrate(() => import('./spm-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SpmIconSvg = dynamicHydrate(() => import('./spm-icon').then((mod) => mod.SpmIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SrbIcon = dynamicHydrate(() => import('./srb-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SrbIconSvg = dynamicHydrate(() => import('./srb-icon').then((mod) => mod.SrbIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SsdIcon = dynamicHydrate(() => import('./ssd-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SsdIconSvg = dynamicHydrate(() => import('./ssd-icon').then((mod) => mod.SsdIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const StpIcon = dynamicHydrate(() => import('./stp-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const StpIconSvg = dynamicHydrate(() => import('./stp-icon').then((mod) => mod.StpIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SurIcon = dynamicHydrate(() => import('./sur-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SurIconSvg = dynamicHydrate(() => import('./sur-icon').then((mod) => mod.SurIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SvkIcon = dynamicHydrate(() => import('./svk-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SvkIconSvg = dynamicHydrate(() => import('./svk-icon').then((mod) => mod.SvkIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SvnIcon = dynamicHydrate(() => import('./svn-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SvnIconSvg = dynamicHydrate(() => import('./svn-icon').then((mod) => mod.SvnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SweIcon = dynamicHydrate(() => import('./swe-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SweIconSvg = dynamicHydrate(() => import('./swe-icon').then((mod) => mod.SweIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SwzIcon = dynamicHydrate(() => import('./swz-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SwzIconSvg = dynamicHydrate(() => import('./swz-icon').then((mod) => mod.SwzIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SxmIcon = dynamicHydrate(() => import('./sxm-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SxmIconSvg = dynamicHydrate(() => import('./sxm-icon').then((mod) => mod.SxmIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SycIcon = dynamicHydrate(() => import('./syc-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SycIconSvg = dynamicHydrate(() => import('./syc-icon').then((mod) => mod.SycIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SyrIcon = dynamicHydrate(() => import('./syr-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const SyrIconSvg = dynamicHydrate(() => import('./syr-icon').then((mod) => mod.SyrIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TcaIcon = dynamicHydrate(() => import('./tca-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TcaIconSvg = dynamicHydrate(() => import('./tca-icon').then((mod) => mod.TcaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TcdIcon = dynamicHydrate(() => import('./tcd-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TcdIconSvg = dynamicHydrate(() => import('./tcd-icon').then((mod) => mod.TcdIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TgoIcon = dynamicHydrate(() => import('./tgo-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TgoIconSvg = dynamicHydrate(() => import('./tgo-icon').then((mod) => mod.TgoIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ThaIcon = dynamicHydrate(() => import('./tha-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ThaIconSvg = dynamicHydrate(() => import('./tha-icon').then((mod) => mod.ThaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TjkIcon = dynamicHydrate(() => import('./tjk-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TjkIconSvg = dynamicHydrate(() => import('./tjk-icon').then((mod) => mod.TjkIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TklIcon = dynamicHydrate(() => import('./tkl-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TklIconSvg = dynamicHydrate(() => import('./tkl-icon').then((mod) => mod.TklIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TkmIcon = dynamicHydrate(() => import('./tkm-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TkmIconSvg = dynamicHydrate(() => import('./tkm-icon').then((mod) => mod.TkmIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TlsIcon = dynamicHydrate(() => import('./tls-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TlsIconSvg = dynamicHydrate(() => import('./tls-icon').then((mod) => mod.TlsIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TonIcon = dynamicHydrate(() => import('./ton-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TonIconSvg = dynamicHydrate(() => import('./ton-icon').then((mod) => mod.TonIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TraIcon = dynamicHydrate(() => import('./tra-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TraIconSvg = dynamicHydrate(() => import('./tra-icon').then((mod) => mod.TraIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TtoIcon = dynamicHydrate(() => import('./tto-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TtoIconSvg = dynamicHydrate(() => import('./tto-icon').then((mod) => mod.TtoIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TunIcon = dynamicHydrate(() => import('./tun-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TunIconSvg = dynamicHydrate(() => import('./tun-icon').then((mod) => mod.TunIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TurIcon = dynamicHydrate(() => import('./tur-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TurIconSvg = dynamicHydrate(() => import('./tur-icon').then((mod) => mod.TurIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TuvIcon = dynamicHydrate(() => import('./tuv-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TuvIconSvg = dynamicHydrate(() => import('./tuv-icon').then((mod) => mod.TuvIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TwnIcon = dynamicHydrate(() => import('./twn-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TwnIconSvg = dynamicHydrate(() => import('./twn-icon').then((mod) => mod.TwnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TzaIcon = dynamicHydrate(() => import('./tza-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const TzaIconSvg = dynamicHydrate(() => import('./tza-icon').then((mod) => mod.TzaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UgaIcon = dynamicHydrate(() => import('./uga-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UgaIconSvg = dynamicHydrate(() => import('./uga-icon').then((mod) => mod.UgaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UkrIcon = dynamicHydrate(() => import('./ukr-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UkrIconSvg = dynamicHydrate(() => import('./ukr-icon').then((mod) => mod.UkrIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UmiIcon = dynamicHydrate(() => import('./umi-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UmiIconSvg = dynamicHydrate(() => import('./umi-icon').then((mod) => mod.UmiIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UnIcon = dynamicHydrate(() => import('./un-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UnIconSvg = dynamicHydrate(() => import('./un-icon').then((mod) => mod.UnIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UryIcon = dynamicHydrate(() => import('./ury-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UryIconSvg = dynamicHydrate(() => import('./ury-icon').then((mod) => mod.UryIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UsaIcon = dynamicHydrate(() => import('./usa-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UsaIconSvg = dynamicHydrate(() => import('./usa-icon').then((mod) => mod.UsaIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UzbIcon = dynamicHydrate(() => import('./uzb-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const UzbIconSvg = dynamicHydrate(() => import('./uzb-icon').then((mod) => mod.UzbIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VatIcon = dynamicHydrate(() => import('./vat-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VatIconSvg = dynamicHydrate(() => import('./vat-icon').then((mod) => mod.VatIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VctIcon = dynamicHydrate(() => import('./vct-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VctIconSvg = dynamicHydrate(() => import('./vct-icon').then((mod) => mod.VctIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VenIcon = dynamicHydrate(() => import('./ven-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VenIconSvg = dynamicHydrate(() => import('./ven-icon').then((mod) => mod.VenIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VgbIcon = dynamicHydrate(() => import('./vgb-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VgbIconSvg = dynamicHydrate(() => import('./vgb-icon').then((mod) => mod.VgbIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VirIcon = dynamicHydrate(() => import('./vir-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VirIconSvg = dynamicHydrate(() => import('./vir-icon').then((mod) => mod.VirIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VnmIcon = dynamicHydrate(() => import('./vnm-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VnmIconSvg = dynamicHydrate(() => import('./vnm-icon').then((mod) => mod.VnmIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VutIcon = dynamicHydrate(() => import('./vut-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const VutIconSvg = dynamicHydrate(() => import('./vut-icon').then((mod) => mod.VutIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WlfIcon = dynamicHydrate(() => import('./wlf-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WlfIconSvg = dynamicHydrate(() => import('./wlf-icon').then((mod) => mod.WlfIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WorldIcon = dynamicHydrate(() => import('./world-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WorldIconSvg = dynamicHydrate(() => import('./world-icon').then((mod) => mod.WorldIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WsmIcon = dynamicHydrate(() => import('./wsm-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const WsmIconSvg = dynamicHydrate(() => import('./wsm-icon').then((mod) => mod.WsmIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const XkxIcon = dynamicHydrate(() => import('./xkx-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const XkxIconSvg = dynamicHydrate(() => import('./xkx-icon').then((mod) => mod.XkxIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const YemIcon = dynamicHydrate(() => import('./yem-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const YemIconSvg = dynamicHydrate(() => import('./yem-icon').then((mod) => mod.YemIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ZafIcon = dynamicHydrate(() => import('./zaf-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ZafIconSvg = dynamicHydrate(() => import('./zaf-icon').then((mod) => mod.ZafIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ZmbIcon = dynamicHydrate(() => import('./zmb-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ZmbIconSvg = dynamicHydrate(() => import('./zmb-icon').then((mod) => mod.ZmbIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ZweIcon = dynamicHydrate(() => import('./zwe-icon'), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
export const ZweIconSvg = dynamicHydrate(() => import('./zwe-icon').then((mod) => mod.ZweIconSvg), {
	loading: function loadingEmptyIcon() {
		return <EmptyIcon />
	},
})
